riot.tag2('reset-control', '<button onclick="{resetMap}" class="ddjnrw-mst-map__reset-control-button btn"> Ansicht zurücksetzen </button>', '', '', function(opts) {

  this.resetMap = () => {
    riot.control.trigger(riot.EVT.resetMap)
  }

});



// WEBPACK FOOTER //
// ./src/components/reset-control.tag